import { integrationRepository, IntegrationStatus } from '@/infrastructure/repositories';
import { HttpError } from '@/domain/entities';

export class IntegrationService {
  async getStatus(integrationId: string): Promise<{ connected: boolean; lastSync?: string }> {
    try {
      return await integrationRepository.getStatus(integrationId);
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error(`Failed to fetch ${integrationId} integration status`);
    }
  }

  async getAllStatuses(): Promise<IntegrationStatus[]> {
    try {
      return await integrationRepository.getAllStatuses();
    } catch (error) {
      if (error instanceof HttpError) {
        throw error;
      }
      throw new Error('Failed to fetch integrations statuses');
    }
  }
}

export const integrationService = new IntegrationService();

